import React, { FormEvent, useEffect, useState } from "react";
import InputField from "src/Components/InputFeild";
import CircleButton from "src/Components/GlobalComponents/CircleButton";
import DatePickerComponent from "src/Components/DatePickerComponent";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMars, faVenus } from "@fortawesome/free-solid-svg-icons";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { errMsg, phoneNumberRegex } from "src/lib/constans";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import { cityList } from "src/Config/CityList";
import {
  decodedToken,
  getLoginUserRole,
  getToken,
  ICustomJwtPayload,
  removeToken,
  validateAddress,
  validateDoctorLicense,
  validateEmail,
  validateFirstName,
  validatePassword,
  validatePhoneNumber,
  validateAndFilterPhoneNumber,
} from "src/helpers/helperFunctions";
import moment from "moment";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/Store/store";
import { setUserDetails } from "src/Store/reducer";
import { setDoctorState } from "src/Store/doctor";
import { setAuth, removeAuth } from "src/Store/reducer";
import Cookies from "js-cookie";
import { doctor, doctorMode } from "src/lib/constans";
import { removeAllIndicators } from "src/Store/redDots";
import SplashScreen from "src/Components/SplashScreen";

interface IPayloadState {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  cnfirmPassword: string;
  gender: string;
  date: string;
  city: string;
  address: string;
  mobile: string;
  licenseNumber: string;
}

const initialState: IPayloadState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  cnfirmPassword: "",
  gender: "",
  date: "",
  city: "",
  address: "",
  mobile: "",
  licenseNumber: "",
};

const initialErroState = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  cnfirmPassword: "",
  gender: "",
  date: "",
  city: "",
  address: "",
  mobile: "",
  licenseNumber: "",
};

const DoctorRegister = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [errorField, setErrorField] = useState(initialErroState);
  const [payload, setPayload] = useState<IPayloadState>(initialState);
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const token = getToken();
  const dispatch = useDispatch<AppDispatch>();

  const handleChange = (key: keyof IPayloadState, val: string) => {
    let value = val;
    let valid = true;
    let errMessage = "";

    if (key === "mobile") {
      const { cleanedValue, isValid, message } = validatePhoneNumber(val);
      value = cleanedValue;
    }

    if (key === "address") {
      // Filter to allow only letters, numbers, spaces, commas, periods, dashes, slashes, hash, and plus
      const filteredValue = val.replace(/[^a-zA-Z0-9\s,.\/#+-]/g, "");
      value = filteredValue;
      let { isValid, message } = validateAddress(filteredValue);
      if (!isValid) {
        valid = false;
        errMessage = message;
      }
    }

    if (key === "password" || key === "cnfirmPassword") {
      if (!validatePassword(value)) {
        valid = false;
        errMessage = errMsg.invalidPassword;
      }
    }

    if (key === "licenseNumber") {
      let { success, cleanedLicense, message } = validateDoctorLicense(value);
      value = cleanedLicense;
      if (!success) {
        valid = false;
        errMessage = message || "";
      }
    }

    setPayload((prev) => ({ ...prev, [key]: value }));
    if (val) {
      setErrorField((prev) => ({ ...prev, [key]: valid ? "" : errMessage }));
    }
  };

  const validateFields = () => {
    const errors: typeof errorField = {
      firstName: payload?.firstName ? "" : "First Name is required.",
      lastName: payload.lastName ? "" : "Last Name is required.",
      email: !payload.email
        ? "Email is required."
        : !validateEmail(payload.email)
        ? errMsg.invalidEmail
        : "",
      mobile: payload.mobile ? phoneNumberRegex.test(payload.mobile) ? "" : "Please enter a valid mobile number" : "Mobile is required.",
      licenseNumber: !payload.licenseNumber
        ? "License is required."
        : !validateDoctorLicense(payload.licenseNumber).success
        ? validateDoctorLicense(payload.licenseNumber).message
        : "",
      date: !payload.date
        ? "Date is required."
        : payload.date?.includes("undefined")
        ? "Date is required."
        : (() => {
            const selectedDate = moment(payload.date, "DD/MM/YYYY");
            const today = moment().startOf("day");
            const minAgeDate = moment().subtract(18, "years").startOf("day");
            const maxAgeDate = moment().subtract(100, "years").startOf("day");

            if (selectedDate.isAfter(today)) {
              return "Date of birth cannot be in the future.";
            }
            if (selectedDate.isAfter(minAgeDate)) {
              return "You must be at least 18 years old.";
            }
            if (selectedDate.isBefore(maxAgeDate)) {
              return "Date of birth cannot be more than 100 years ago.";
            }
            return "";
          })(),
      gender: payload.gender ? "" : "Gender is required.",
      address: payload.address ? "" : "Address is required.",
      city: payload.city ? "" : "City is required.",
      password: !payload.password
        ? "Password is required."
        : !validatePassword(payload.password)
        ? errMsg.invalidPassword
        : "",
      cnfirmPassword: !payload.cnfirmPassword
        ? "Confirm password is required."
        : payload.password !== payload.cnfirmPassword
        ? "Password and Confirm password must match."
        : "",
    };
    setErrorField(errors);
    // Check if there are any errors
    return !Object.values(errors).some((error) => error !== "");
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (validateFields()) {
      setIsLoader(true);
      const { cnfirmPassword, ...actualPayload } = payload;
      const { res, err } = await httpRequest<{
        message: string;
        otpExp: string;
      }>({
        method: "post",
        path: "/customer/registor",
        params: { ...actualPayload, userRole: "doctor" },
      });
      if (res) {
        const { message = "" } = res;
        toast(message || "Success!", { type: "success" });
        setErrorField(initialErroState);
        setPayload(initialState);
        // Store relevant information in Cookies
        let obj = {
          email: payload.email,
          otpExpire: moment().add(2, "minutes").toISOString(),
          purpose: "register",
        };
        sessionStorage.setItem(
          "doctorTwoFactor" as string,
          JSON.stringify(obj)
        );
        navigate("/doctor/otp");
        // navigate("/doctor/login");
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  const formatToDisplay = (date: string): string => {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`; // DD/MM/YYYY
  };

  // Format YYYY-MM-DD for the input field
  const formatToInput = (date: string): string => {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`; // YYYY-MM-DD
  };

  const fetchProfile = async (_token: string) => {
    const { res, err } = await httpRequest<any>({
      path: `/doctors/profile/${decodedToken(_token)?.id}`,
      token: _token,
    });
    if (res) {
      dispatch(setUserDetails(res));
      dispatch(setDoctorState(res?._id));
      dispatch(setAuth(_token));
      Cookies.set(doctorMode, doctor);
      navigate("/dashboard");
      setPageLoader(false);
    } else {
      toast(err, { type: "error" });
      dispatch(removeAuth()); // logout
      dispatch(removeAllIndicators());
      removeToken();
      navigate("/doctor/login");
      setPageLoader(false);
    }
  };

  useEffect(() => {
    if (token && getLoginUserRole() === "doctor") {
      setPageLoader(true);
      fetchProfile(token);
    }
  }, [token]);

  return (
    <div className="customer-register-main">
      {pageLoader && <SplashScreen />}
      <div className="container-1600">
        <div className="customer-login-main-inner">
          <div>
            <h1 className="font-Poppins-SemiBold font-size-32px theme-color-green leading-none text-center lg-main-head">
              {/* Doctor Registration */}
              Create Account
            </h1>
            <p className="font-size-16px theme-color-green text-center font-Poppins-Regular">
              Have an account?{" "}
              <Link
                to="/doctor/login"
                id="signInLink"
                className="font-Poppins-SemiBold underline hover:no-underline"
              >
                Sign in
              </Link>
            </p>
          </div>
          <form
            onSubmit={handleSubmit}
            className="customer-register-main-inner-main"
          >
            <div className="register-form-feilds-main">
              <div className="grid grid-cols-2 register-form-feilds-main-inner">
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="firstName"
                    label="First name"
                    value={payload.firstName}
                    onChange={(val: string) =>
                      handleChange("firstName", validateFirstName(val))
                    }
                  />
                  {errorField?.firstName && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.firstName}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="lastName"
                    label="Last name"
                    value={payload.lastName}
                    onChange={(val: string) =>
                      handleChange("lastName", validateFirstName(val))
                    }
                  />
                  {errorField?.lastName && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.lastName}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="email"
                    label="Email"
                    value={payload.email}
                    onChange={(val: string) => handleChange("email", val)}
                  />
                  {errorField?.email && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.email}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="phoneNumber"
                    label="Phone"
                    type="text"
                    value={payload.mobile}
                    onChange={(val: string) => {
                      const { filteredValue, errorMessage } = validateAndFilterPhoneNumber(val);
                      handleChange("mobile", filteredValue);
                      setErrorField((prev) => ({
                        ...prev,
                        mobile: errorMessage,
                      }));
                    }}
                  />
                  {errorField?.mobile && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.mobile}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="doctorLiscence"
                    // label="Doctor License Number"
                    label="PMDC Number"
                    value={payload.licenseNumber}
                    onChange={(val: string) =>
                    {
                      let val2 = val.toLocaleUpperCase()
                      
                      handleChange("licenseNumber", val2)
                    }
                    }
                  />
                  {errorField?.licenseNumber && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.licenseNumber}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    type="date"
                    label="Date of Birth"
                    value={formatToInput(payload.date)}
                    id="dateOfBirth" // Pass value in YYYY-MM-DD format to input
                    onChange={(val: string) => {
                      // Convert input date to moment object and set time to midnight
                      const inpDate = moment(val).startOf("day");

                      // Current date using moment
                      const cDate = moment().startOf("day");

                      // Date 18 years ago using moment
                      const minAgeDate = moment()
                        .subtract(18, "years")
                        .startOf("day");

                      // Date 100 years ago using moment
                      const maxAgeDate = moment()
                        .subtract(100, "years")
                        .startOf("day");

                      // Check if the date is in the future
                      if (inpDate.isAfter(cDate)) {
                        toast.error("Date of birth cannot be in the future.");
                        setErrorField((prev) => ({
                          ...prev,
                          date: "Date of birth cannot be in the future.",
                        }));
                        return;
                      }

                      // Check if the user is at least 18 years old
                      if (inpDate.isAfter(minAgeDate)) {
                        toast.error("You must be at least 18 years old.");
                        setErrorField((prev) => ({
                          ...prev,
                          date: "You must be at least 18 years old.",
                        }));
                        return;
                      }

                      // Check if the user is not more than 100 years old
                      if (inpDate.isBefore(maxAgeDate)) {
                        toast.error(
                          "Date of birth cannot be more than 100 years ago."
                        );
                        setErrorField((prev) => ({
                          ...prev,
                          date: "Date of birth cannot be more than 100 years ago.",
                        }));
                        return;
                      }

                      // Clear any previous date errors
                      setErrorField((prev) => ({ ...prev, date: "" }));
                      handleChange("date", formatToDisplay(val));
                    }}
                    max={(() => {
                      const today = new Date();
                      const maxDate = new Date(
                        today.getFullYear() - 18,
                        today.getMonth(),
                        today.getDate()
                      );
                      return maxDate.toISOString().split("T")[0];
                    })()}
                  />
                  {errorField?.date && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.date}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <label
                    className="font-Poppins-Medium text-white font-size-16px"
                    htmlFor=""
                  >
                    Gender
                  </label>
                  <div className="genders-select">
                    <span
                      id="genderMale"
                      className={`font-size-18px input-btns-height-50px font-Poppins-Regular ${
                        payload.gender === "male" ? "genders-select-active" : ""
                      }`}
                      onClick={() => handleChange("gender", "male")}
                    >
                      <FontAwesomeIcon icon={faMars} /> Male
                    </span>
                    <span
                      id="genderFeMale"
                      className={`font-size-18px input-btns-height-50px font-Poppins-Regular ${
                        payload.gender === "female"
                          ? "genders-select-active"
                          : ""
                      }`}
                      onClick={() => handleChange("gender", "female")}
                    >
                      <FontAwesomeIcon icon={faVenus} /> Female
                    </span>
                  </div>
                  {errorField?.gender && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.gender}
                    </p>
                  )}
                </div>
                <div className="col-span-2">
                  <InputField
                    id="address"
                    label="Address"
                    value={payload.address}
                    onChange={(val: string) => handleChange("address", val)}
                    maxLength={100}
                  />
                  {errorField?.address && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.address}
                    </p>
                  )}
                </div>
                <div className="col-span-2 city-dropdown-option">
                  <CustomWebsiteDropdown
                    labelText="City"
                    options={cityList}
                    data={cityList.filter((v) => v?.value === payload.city)}
                    setData={(e) => handleChange("city", e[0]?.value || "")}
                    isMulti={false}
                    extraClass="!mb-0"
                    dropdownInnerClass="input-btns-height-50px font-Poppins-SemiBold"
                    dropdownPosition="top"
                    dropdownMainId="city-dropdown"
                    dropdownMainStyle={{
                      borderRadius: "10px",
                    }}
                  />
                  {errorField?.city && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.city}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="password"
                    type="password"
                    label="Password"
                    value={payload.password}
                    onChange={(val: string) => handleChange("password", val)}
                  />
                  {errorField?.password && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.password}
                    </p>
                  )}
                </div>
                <div className="col-span-2 md:col-span-1">
                  <InputField
                    id="confirmPassword"
                    type="password"
                    label="Confirm Password"
                    value={payload.cnfirmPassword}
                    onChange={(val: string) =>
                      handleChange("cnfirmPassword", val)
                    }
                  />
                  {errorField?.cnfirmPassword && (
                    <p className="font-size-14px text-[#ff0000] font-Poppins-Regular">
                      {errorField?.cnfirmPassword}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="login-btn-home-banner-parent flex items-center justify-center">
              <CircleButton
                id="submit_btn"
                ButtonText={"Create Account"}
                loader={isLoader}
                type={"submit"}
                btnExtralClasses={"border border-[#00443f] hover:shadow-md"}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DoctorRegister;
